import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { noop } from 'rxjs';
import { ServiceStock } from 'src/app/service-stock.service';

const customCss: string = '';

@Component({
    selector: 'app-Stock',
    templateUrl: './Stock.component.html',
    styleUrls: ['./Stock.component.scss']
})

export class StockComponent implements OnInit {

    @Input('width') width: string | number = 200;
    @Input('height') height: string | number = 28;
    @Input('minLength') minLength: number = 1;
    @Input('displayLabel') displayLabel: boolean;
    @Input('label') label: string;
    @Input('searchMode') searchMode: string = "symbol";
    @Input('searchModeToggle') searchModeToggle: boolean = false;
    @ViewChild('gotxInput', { static: false }) gotxInput: jqxInputComponent;
    // @ViewChild("cmbStock", { static: false }) cmbStock: jqxInputComponent;
    @Input('productSelected') productSelected: string;



    @Output() stockSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() searchModeSelected: EventEmitter<any> = new EventEmitter<any>();

    // searchMode: string = "companyName";
    searchClass: string = "fa fa-signal";

    source = [];
    placeHolder = "Select stock";

    error = false;
    errorMessage = "";
    alphaNumericPattern = "^[a-zA-Z0-9 &()-.]*$";
    upto12 = "^[a-zA-Z0-9 &()]{0,12}$";
    hidden: boolean = false;
    readOnly: boolean = false;
    stockCodeSize: number = 45;
    displaySymbol: string;

    constructor(private services: ServiceStock) { }


    ngOnInit(): void {
        this.changeSearchMode(this.searchMode);

    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['productSelected']) {
            this.handleProductDataChange(changes['productSelected'].currentValue);
        }
    }
    handleProductDataChange(newData: string): void {
        if (newData == "EQUITY") {
            this.displaySymbol = "EQUITY";
            setTimeout(() => {
                this.gotxInput.searchMode('startswithignorecase');
            }, 200);

        } else if (newData == "COMDERV" || newData == "FUTOPT") {
            this.displaySymbol = "OTHERS";
            this.searchClass = "fa fa-signal";
            console.log("this.gotxInput", this.gotxInput);

            setTimeout(() => {
                console.log("this.gotxInput in timeout", this.gotxInput);
                this.gotxInput.displayMember("symbol");
                this.gotxInput.searchMode('containsignorecase');
            }, 200);
            // this.gotxInput.searchMode('containsignorecase');
        }
    }

    settings: jqwidgets.InputOptions = {
        displayMember: "symbol",
        valueMember: "exchSymbol"
    }

    ngAfterViewInit(): void {
        //Selected Symbol Delete Issue
        //this.gotxInput.createComponent(this.settings);
        //this.gotxInput.valueMember(this.settings.valueMember);
        this.gotxInput.createComponent();
        this.gotxInput.setOptions(this.settings);
        this.gotxInput.displayMember(this.searchMode);
        //this.gotxInput.searchMode('startswithignorecase');
        this.gotxInput.searchMode('containsignorecase');
        this.changeSearchMode(this.searchMode);
        this.gotxInput.registerOnChange(this.OnValueChange);
        /*
        if (this.gotxInput) {
            setTimeout(_ =>
                this.gotxInput.host.on('change', (eventData: any) => {
                    if (eventData.args === undefined || eventData.args.value === undefined) {
                        console.log('eventData', eventData);
                        var inputValue = eventData.target.value;
                        if (inputValue.length <= 0) { inputValue = null; }
                        this.gotxInput.host.jqxInput('val', { label: inputValue, value: inputValue });
                    }
                })
            );
        }*/
    }



    OnValueChange(event): void {
        //console.log('EVENT : ', event);
        this.val(event);
    }

    private val: (_: any) => void = noop;

    changeSearchMode(type: string) {
        this.searchMode = type;

        if (type == "symbol") {
            this.searchClass = "fa fa-signal";
            if (this.gotxInput)
                this.gotxInput.maxLength(this.stockCodeSize);
        } else {
            this.searchClass = "fa fa-university";
            if (this.gotxInput)
                this.gotxInput.maxLength(-1);
        }

        if (this.gotxInput) {
            this.gotxInput.displayMember(type);
            //this.gotxInput.valueMember(this.settings.valueMember);
        }

        this.searchModeSelected.emit(this.searchMode);
    }

    onSelect(event: any): void {
        // // this.stockSelected.emit(this.gotxInput.val());
        // // console.log("val: ", this.gotxInput.val());
        // // console.log("event", event);
        // // let stockVal = this.gotxInput.val();
        // let stockVal = this.gotxInput.ngValue;
        // // console.log(stockVal);
        // // console.log(this.gotxInput.ngValue);
        // // console.log(this.gotxInput);
        // // console.log(this.alphaNumericPattern);
        // // console.log(this.searchMode);

        // if (!(stockVal.toString().match(this.alphaNumericPattern))) {
        //     // console.log("not valid");
        //     this.setError("Stock should be alpha numeric");
        // }
        // else if (this.searchMode == "symbol" && !(stockVal.toString().match(this.upto12))) {
        //     // console.log("not valid");
        //     this.setError("Stock length should not exceeds 12 character");
        // }
        // else {
        //     // console.log("valid");
        //     // this.error = false;
        //     this.setError("", false);
        //     this.stockSelected.emit(stockVal);
        // }
    }

    onChange(event: any): void {
        // this.stockSelected.emit(this.gotxInput.val());
        // console.log("val: ", this.gotxInput.val());
        // console.log("event", event);
        // let stockVal = this.gotxInput.val();
        if (event && event.args) {
            var inputValue = event.args.label;
            this.gotxInput.host.jqxInput('val', { label: inputValue, value: event.args.value });
        }

        let stockVal = this.gotxInput.ngValue;
        // console.log(stockVal);
        // console.log(this.gotxInput.ngValue);
        // console.log(this.gotxInput);
        // console.log(this.alphaNumericPattern);
        // console.log(this.searchMode);

        if (!(stockVal.toString().match(this.alphaNumericPattern))) {
            // console.log("not valid");
            this.setError("Stock should be alpha numeric");
        }
        //else if (this.searchMode == "symbol" && !(stockVal.toString().match(this.upto12))) {
        // console.log("not valid");
        //    this.setError("Stock length should not exceeds 12 character");
        //}
        else {
            // console.log("valid");
            // this.error = false;
            this.setError("", false);
            this.stockSelected.emit(stockVal);
        }
    }

    setHidden(value: boolean) {
        this.hidden = value;
    }

    isHidden() {
        return this.hidden;
    }

    setReadOnly(value: boolean) {
        this.readOnly = value;
    }

    setError(err, isErr = true) {
        this.errorMessage = err;
        this.error = isErr;
    }
}